export default __webpack_public_path__ + "static/media/laboratoryBox.7436725b.jpg";